export const APP_NAME = "KLIPO"
export const APP_LOGO = "https://static.lumi.new/95/95c6687fa248a84e0201b0c783242fb6.webp"
export const APP_TAGLINE = "Clip the culture. Own the moment."
export const TOKEN_LOGO = "https://static.lumi.new/f2/f26a6a091baa3c6e0c211c8d4d29a014.webp"
export const COMING_SOON_ART = "https://static.lumi.new/37/37954ff14cd17c0373ec8c61380969af.webp"
export const X_URL = "https://x.com/KLIPO_MEDIA"
export const COMING_SOON_KEY = "comingSoon"
